
//Représente les données d’une colonne
export class DonneesColonne {
	//Création
	constructor() {
		this.identifiant = "";
		this.champ = "";
		this.libelle = "";
		this.format = "";
		this.taille = 100;
		this.visible = true;
		this.couleurParDefaut = null;
	}

	//Identifiant
	public identifiant: string;

	//Champ
	public champ: string;

	//Libellé
	public libelle: string;

	//Format
	public format: string;

	//Taille
	public taille: number;

	//Visible
	public visible: boolean;

	//Couleur par défaut
	public couleurParDefaut?: string | null = null;
}
/*
  TXT
  INT
  DAT
  DAT_H
  CUR
  CUR_SIGN
  DEC
  CHK
  TXT_COLOR
  BTN_ICON
*/

//Représente les données de clic sur l'icone d'une colonne BTN_ICON
export class DonneesColonneBoutonIconeClick {
	//Création
	constructor() {
		this.identifiant = null;
		this.champ = "";
	}

	//Identifiant de la ligne
	public identifiant: any | null;

	//Champ de la colonne
	public champ: string;
}

//Représente les données de sélection d’une grille
export class DonneesGrilleSelection {
	//Création
	constructor() {
		this.identifiantFocus = null;
		this.identifiantsSelectionnes = [];
	}

	//Identifiant de la ligne ayant le focus
	public identifiantFocus: any | null;

	//Identifiants des lignes sélectionnées
	public identifiantsSelectionnes: any[];
}

//Représente les données de description d’un filtre
export class DescriptionFiltre {
	//Création
	constructor() {
		this.champ = "";
		this.operateur = "";
		this.valeurTexte = null;
		this.valeurInt = null;
		this.valeurDate = null;
		this.valeurDecimale = null;
		this.valeurBoolean = null;
	}

	//Champ
	public champ: string;

	//Opérateur
	public operateur: string;

	//Valeur texte
	public valeurTexte: string | null;

	//Valeur int
	public valeurInt: number | null;

	//Valeur date
	public valeurDate: Date | null;

	//Valeur décimale
	public valeurDecimale: number | null;

	//Valeur boolean
	public valeurBoolean: boolean | null;
}

//Représente les données de visibilite d’une colonne
export class VisibiliteColonne {
	//Création
	constructor() {
		this.identifiant = "";
		this.visible = false;
	}

	//Identifiant
	public identifiant: string;

	//Nouveau ordre
	public visible: boolean;
}

//Représente les données de taille d’une colonne
export class TailleColonne {
	//Création
	constructor() {
		this.identifiant = "";
		this.taille = 0;
	}

	//Identifiant
	public identifiant: string;

	//Nouveau ordre
	public taille: number;
}

//Représente les données de groupe d’une colonne
export class GroupeColonne {
	//Création
	constructor() {
		this.identifiant = "";
		this.sens = "";
	}

	//Identifiant
	public identifiant: string;

	//Sens
	public sens: string;
}
